import type { TranslationDict } from '../en';

const ur: TranslationDict = {
  // ─── Header ───
  'header.buy': 'خریدیں',
  'header.sell': 'بیچیں',

  // ─── SpendCard ───
  'spend.label': 'آپ خرچ کریں گے',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',

  // ─── ReceiveCard ───
  'receive.label': 'آپ کو ملے گا',

  // ─── PaymentCard ───
  'payment.label': 'ادائیگی کا طریقہ',
  'payment.select': 'منتخب کریں',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'اس جوڑے کے لیے کوئی ادائیگی کا طریقہ دستیاب نہیں',

  // ─── WalletCard ───
  'wallet.label': 'وصول کرنے والا والیٹ پتہ',
  'wallet.placeholderBuy': 'اپنا وصولی پتہ درج کریں',
  'wallet.placeholderSell': 'اپنا بھیجنے کا پتہ درج کریں',
  'wallet.validating': 'پتہ تصدیق ہو رہا ہے...',
  'wallet.invalid': 'درست والیٹ پتہ درج کریں',
  'wallet.invalidServer': 'غلط والیٹ پتہ',

  // ─── CtaButton ───
  'cta.buy': '{crypto} خریدیں',
  'cta.sell': '{crypto} بیچیں',
  'cta.gettingPrice': 'بہترین قیمت حاصل کی جا رہی ہے...',
  'cta.processing': 'پروسیس ہو رہا ہے...',

  // ─── Footer ───
  'footer.poweredBy': 'کی طرف سے ',
  'footer.brand': 'NowRamp',

  // ─── Rate Breakdown ───
  'rate.title': 'شرح کی تفصیل',
  'rate.close': 'بند کریں',
  'rate.updatesIn': 'شرح 00:{seconds} میں اپڈیٹ ہوگی',
  'rate.noQuote': 'کوئی قیمت دستیاب نہیں',
  'rate.exchangeRate': 'تبادلہ شرح',
  'rate.processingFee': 'پروسیسنگ فیس',
  'rate.networkFee': 'نیٹ ورک فیس',
  'rate.provider': 'فراہم کنندہ',

  // ─── Toast ───
  'toast.orderCreated': 'آرڈر بن گیا',
  'toast.redirecting': 'چیک آؤٹ کی طرف بھیجا جا رہا ہے...',
  'toast.orderFailed': 'آرڈر ناکام ہو گیا',
  'toast.couldNotCreate': 'آرڈر نہیں بنایا جا سکا',
  'toast.quoteError': 'قیمت کی خرابی',
  'toast.noProviders': 'کوئی فراہم کنندہ نہیں',
  'toast.somethingWrong': 'کچھ غلط ہو گیا',

  // ─── Form errors ───
  'error.amountZero': 'رقم 0 سے زیادہ ہونی چاہیے',
  'error.minAmountFiat': 'کم از کم رقم {min} {currency} ہے',
  'error.minAmountCrypto': 'کم از کم رقم {min} {currency} ہے',
  'error.noProviders': 'اس مجموعے کے لیے کوئی فراہم کنندہ دستیاب نہیں',
  'error.currencyUnavailableBuy': 'یہ کرنسی خریداری کے آرڈر کے لیے دستیاب نہیں',
  'error.currencyUnavailableSell': 'یہ کرنسی فروخت کے آرڈر کے لیے دستیاب نہیں',

  // ─── Parity banner ───
  'parity.info': 'آپ سے {receiveAmount} {crypto} کے لیے چارج کیا جائے گا، باقی {spendAmount} {fiat} تک آپ کے {partner} اکاؤنٹ میں جمع ہو جائے گا',

  // ─── Redirect Screen ───
  'redirect.secureBadge': 'محفوظ ادائیگی',
  'redirect.title': 'ادائیگی جاری رکھیں',
  'redirect.description': 'ادائیگی مکمل کرنے کے لیے آپ کو {gateway} پر بھیجا جائے گا۔',
  'redirect.countdown': '{seconds} سیکنڈ میں منتقل ہو رہے ہیں...',
  'redirect.openTab': 'نئے ٹیب میں ACH کھولیں',
  'redirect.cancel': 'منسوخ کریں',

  // ─── Checkout Step ───
  'checkout.noOrder': 'کوئی آرڈر نہیں ملا',
  'checkout.goBack': 'واپس جائیں',
  'checkout.expired': 'چیک آؤٹ کی میعاد ختم',
  'checkout.expiredDesc': 'سیشن کی میعاد ختم ہو گئی ہے۔ دوبارہ کوشش کریں۔',
  'checkout.startOver': 'دوبارہ شروع کریں',
  'checkout.cancel': 'منسوخ کریں',
  'checkout.loading': 'چیک آؤٹ لوڈ ہو رہا ہے...',
  'checkout.iframeTitle': 'فراہم کنندہ چیک آؤٹ',
  'checkout.widgetTitle': 'ادائیگی چیک آؤٹ',
  'checkout.unknownMethod': 'نامعلوم چیک آؤٹ طریقہ',

  // ─── Processing Step ───
  'processing.default': 'آپ کا آرڈر پروسیس ہو رہا ہے...',
  'processing.pending': 'ادائیگی کی تصدیق کا انتظار ہے...',
  'processing.active': 'آپ کا لین دین پروسیس ہو رہا ہے...',
  'processing.generic': 'پروسیس ہو رہا ہے...',
  'processing.checkingStatus': 'اسٹیٹس چیک ہو رہا ہے...',
  'processing.orderId': 'آرڈر آئی ڈی',
  'processing.provider': 'فراہم کنندہ',
  'processing.amount': 'رقم',
  'processing.receiving': 'وصولی',
  'processing.network': 'نیٹ ورک',
  'processing.toAddress': 'وصول کنندہ پتہ',
  'processing.usuallyMinutes': 'اس میں عام طور پر چند منٹ لگتے ہیں۔',
  'processing.safeToClose': 'آپ یہ صفحہ بند کر سکتے ہیں — مکمل ہونے پر ہم آپ کو ای میل کریں گے۔',

  // ─── Complete Step ───
  'complete.buyTitle': 'خریداری مکمل!',
  'complete.sellTitle': 'فروخت مکمل!',
  'complete.buyDesc': 'آپ کا {crypto} آپ کے والیٹ میں بھیج دیا گیا ہے۔',
  'complete.sellDesc': 'آپ کی {fiat} ادائیگی پروسیس ہو رہی ہے۔',
  'complete.amountBuy': 'موصول شدہ رقم',
  'complete.amountSell': 'فروخت کی گئی رقم',
  'complete.paidBuy': 'ادا کی گئی رقم',
  'complete.paidSell': 'ادائیگی کی رقم',
  'complete.network': 'نیٹ ورک',
  'complete.wallet': 'والیٹ',
  'complete.transaction': 'لین دین',
  'complete.provider': 'فراہم کنندہ',
  'complete.orderId': 'آرڈر آئی ڈی',
  'complete.completed': 'مکمل',
  'complete.viewExplorer': 'ایکسپلورر پر دیکھیں',
  'complete.done': 'ہو گیا',

  // ─── Error Step ───
  'errorStep.failed': 'ادائیگی ناکام',
  'errorStep.cancelled': 'آرڈر منسوخ',
  'errorStep.expired': 'آرڈر کی میعاد ختم',
  'errorStep.refunded': 'آرڈر واپس کر دیا گیا',
  'errorStep.unknown': 'کچھ غلط ہو گیا',
  'errorStep.failedBuy': 'آپ کی ادائیگی پروسیس نہیں ہو سکی۔ دوبارہ کوشش کریں یا کوئی دوسرا ادائیگی طریقہ استعمال کریں۔',
  'errorStep.failedSell': 'آپ کی فروخت پروسیس نہیں ہو سکی۔ دوبارہ کوشش کریں۔',
  'errorStep.cancelledBuy': 'آپ کا آرڈر منسوخ کر دیا گیا۔ کوئی ادائیگی پروسیس نہیں ہوئی۔',
  'errorStep.cancelledSell': 'آپ کی فروخت منسوخ کر دی گئی۔ کوئی کریپٹو منتقل نہیں ہوا۔',
  'errorStep.expiredBuy': 'آپ کے آرڈر کی میعاد ختم ہو گئی۔ نئی خریداری شروع کریں۔',
  'errorStep.expiredSell': 'آپ کے آرڈر کی میعاد ختم ہو گئی۔ نئی فروخت شروع کریں۔',
  'errorStep.refundedBuy': 'آپ کی ادائیگی واپس کر دی گئی ہے۔ رقم 5-10 کاروباری دنوں میں آپ کے اکاؤنٹ میں نظر آئے گی۔',
  'errorStep.refundedSell': 'آپ کا کریپٹو واپس کر دیا گیا ہے۔ رقم جلد آپ کے والیٹ میں نظر آئے گی۔',
  'errorStep.genericDesc': 'ایک غیر متوقع خرابی پیش آئی۔ دوبارہ کوشش کریں۔',
  'errorStep.orderId': 'آرڈر آئی ڈی',
  'errorStep.tryAgain': 'دوبارہ کوشش کریں',
  'errorStep.startOver': 'دوبارہ شروع کریں',
  'errorStep.return': 'واپس جائیں',
  'errorStep.needHelp': 'مدد چاہیے؟ رابطہ کریں ',
  'errorStep.reference': 'حوالہ: {orderId}',

  // ─── Confirm Step ───
  'confirm.buyTitle': 'خریداری کی تصدیق کریں',
  'confirm.sellTitle': 'فروخت کی تصدیق کریں',
  'confirm.loading': 'لوڈ ہو رہا ہے...',
  'confirm.provider': 'فراہم کنندہ',
  'confirm.youPay': 'آپ ادا کریں گے',
  'confirm.youSell': 'آپ بیچیں گے',
  'confirm.youReceive': 'آپ حاصل کریں گے',
  'confirm.wallet': 'والیٹ',
  'confirm.network': 'نیٹ ورک',
  'confirm.refundAddress': 'واپسی کا پتہ',
  'confirm.parityNote': 'فراہم کنندہ کی طرف سے چارج کی جانے والی رقم مختلف ہو سکتی ہے۔ باقی {amount} {crypto} تک آپ کے {partner} اکاؤنٹ میں جمع ہوگا۔',
  'confirm.processing': 'پروسیس ہو رہا ہے...',
  'confirm.confirmPay': 'تصدیق کریں اور ادا کریں',
  'confirm.confirmSell': 'تصدیق کریں اور بیچیں',
  'confirm.payout': '{currency} ادائیگی',

  // ─── Modals ───
  'modal.selectFiat': 'فیاٹ کرنسی منتخب کریں',
  'modal.selectCrypto': 'کریپٹو کرنسی منتخب کریں',
  'modal.choosePayment': 'ادائیگی کا طریقہ منتخب کریں',
  'modal.selectCountry': 'اپنا ملک منتخب کریں',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'مقبول',
  'modal.recommended': 'تجویز کردہ',
  'modal.noCurrencies': 'کوئی کرنسی نہیں ملی',
  'modal.noPaymentMethods': 'کوئی ادائیگی کا طریقہ نہیں ملا',
  'modal.noCountries': 'کوئی ملک نہیں ملا',
  'modal.noLanguages': 'No languages found',

  // ─── Settings ───
  'settings.location': 'مقام',
  'settings.darkMode': 'ڈارک موڈ',
  'settings.privacy': 'رازداری کی پالیسی',
  'settings.terms': 'استعمال کی شرائط',
  'settings.language': 'زبان',

  // ─── Additional ───
  'modal.chooseRamp': 'Ramp منتخب کریں',
  'modal.bestPrice': 'بہترین قیمت',
  'modal.noQuotes': 'اس درخواست کے لیے کوئی قیمت دستیاب نہیں',
  'modal.noProvidersFound': 'کوئی فراہم کنندہ نہیں ملا',
  'payment.unavailableFor': '{currency} کے لیے کوئی ادائیگی کا طریقہ دستیاب نہیں',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'آرڈر بنانے میں ناکامی',
  'errorStep.returnToMerchant': 'تاجر کے پاس واپس جائیں',
  'confirm.cryptoOnNetwork': '{crypto} پر {network}',
  'payment.name.card': 'کارڈ',
  'payment.name.bankTransfer': 'بینک منتقلی',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ur;
